import { memo } from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { Box, Text } from '@mantine/core';
import { IconGitBranch } from '@tabler/icons-react';

function IfNode({ data, selected }: NodeProps) {
  return (
    <Box
      style={{
        background: '#fef3c7',
        border: `2px solid ${selected ? '#f59e0b' : '#fbbf24'}`,
        borderRadius: '8px',
        padding: '10px 14px',
        minWidth: '120px',
        boxShadow: selected ? '0 4px 12px rgba(245, 158, 11, 0.3)' : '0 2px 8px rgba(0, 0, 0, 0.1)',
        textAlign: 'center',
      }}
    >
      <Handle type="target" position={Position.Top} />
      <Box style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' }}>
        <IconGitBranch size={20} color="#f59e0b" />
        <Text size="xs" fw={600} c="#92400e">
          IF CONDITION
        </Text>
      </Box>
      <Handle
        type="source"
        position={Position.Bottom}
        id="true"
        style={{ left: '30%', background: '#22c55e' }}
      />
      <Handle
        type="source"
        position={Position.Bottom}
        id="false"
        style={{ left: '70%', background: '#ef4444' }}
      />
    </Box>
  );
}

export default memo(IfNode);
